import { Grid, Stack, Typography } from "@mui/material";
/**A span or a link in the footer
 * @param {Object} props props
 * @param props.children children
 * @param {string} props.href the url to go to on click if it is a link
 * @param {boolean} props.bold Whether to bold the text or not
 * @param {Object} props.sx Styling object to add to styles
 * @param {string} props.black A string either 'black' or '', adds the class 'black' to the classlist
 * @param {boolean} props.sp Whether to return span or a
 */
const FooterLinks = ({
  children,
  href,
  bold = true,
  sx,
  black = "",
  sp = false,
}) => {
  const style = {
    ...sx,
    fontFamily: "Montserrat",
    fontWeight: bold ? 400 : 200,
    marginRight: "2vw",
    fontSize: {
      xs: "0.8rem",
      sm: "1rem",
    },
  };
  return (
    <>
      {sp ? (
        <Typography
          component={"span"}
          style={style}
          className={"FooterLinks sp " + black}
        >
          {children}
        </Typography>
      ) : (
        <Typography
          component={"a"}
          href={href}
          style={style}
          className={"FooterLinks " + black}
        >
          {children}
        </Typography>
      )}
    </>
  );
};

/**A group of footer links
 * @param {Object} props props
 * @param {boolean} props.black whether to make the links black or white
 * @param {boolean} props.lp changes the order of the links depending on whether it is being rendered on
 * the left panel or not (Left panel was removed)
 */
export const BottomLinks = ({ black = false, lp = false }) => {
  return (
    <>
      <FooterLinks
        black={black ? "black" : ""}
        sx={{ order: lp ? 3 : 1 }}
        href="https://little.africa/tnc_ind.php"
      >
        Terms and policies
      </FooterLinks>
      <FooterLinks
        black={black ? "black" : ""}
        sx={{ order: 2 }}
        href="https://little.bz/privacy.html"
      >
        Privacy
      </FooterLinks>
      <FooterLinks sp black={black ? "black" : ""} sx={{ order: lp ? 1 : 3 }}>
        &copy; Copyright 2022
      </FooterLinks>
    </>
  );
};

const LeftPanel = ({ children }) => {
  return (
    <>
      <Grid item xs={12} lg={4} className="beut">
        <Stack
          sx={{
            pt: 5,
            height: "100%",
            width: "calc(100% * 4/12)",
            backgroundImage: "url(/jpg/seatBG.jpg)",
            backgroundSize: "cover",
            backgroundPositionX: "center",
            position: "fixed",
          }}
        >
          <Typography
            variant="h3"
            color="white"
            sx={{
              width: 400,
              mx: "auto",
              mt: 2,
              flexGrow: 1,
              fontFamily: "Maven Pro",
            }}
          >
            {children}
          </Typography>
          <Stack
            direction={"column-reverse"}
            sx={{ flexGrow: 9, width: "100%", alignItems: "center" }}
          >
            <BottomLinks lp />
          </Stack>
          <Stack sx={{ flexGrow: 3 }}></Stack>
        </Stack>
      </Grid>
    </>
  );
};
export default LeftPanel;
